export const generateRandomNumber = (n) => {
    return Math.floor(Math.random() * (9 * Math.pow(10, n - 1))) + Math.pow(10, n - 1);
  }
export  const cuttext = (text, maxlength) => {
    if (text && text.length > maxlength) {
        var newtext = text.slice(0, maxlength);
        newtext += "..."
        return newtext
    } else return text
}